class CookieToast extends HTMLElement {
  constructor() {
    super();
    this.duration = parseInt(this.getAttribute("duration") || 60000);
    this.storageKey = this.getAttribute("storage-key") || "cookie_toast_shown";
    this._timeout = null;
  }

  connectedCallback() {
    // Check if toast should appear only once
    if (this.hasAttribute("once") && localStorage.getItem(this.storageKey)) {
      this.remove();
      return;
    }

    // Add close button
    this.insertAdjacentHTML(
      "beforeend",
      `
      <div class="close-btn" aria-label="close">
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
          <path d="M4 4L16 16M16 4L4 16" stroke="black" stroke-width="1.5"/>
        </svg>
      </div>
    `
    );

    this.querySelector(".close-btn").addEventListener("click", () => this.hide());

    // Show animation
    requestAnimationFrame(() => {
      this.classList.add("show");
    });

    // Auto-hide
    this._timeout = setTimeout(() => this.hide(), this.duration);

    // Mark as shown
    if (this.hasAttribute("once")) {
      localStorage.setItem(this.storageKey, "true");
    }
  }

  hide() {
    this.classList.add("hide");
    setTimeout(() => this.remove(), 450);
  }

  disconnectedCallback() {
    clearTimeout(this._timeout);
  }
}

customElements.define("cookie-toast", CookieToast);
